import { Stack } from "@vapor/react-material";
import { CslFormSmartDemo } from "../components/csl-form-smart";
import { SectionalDemo } from "../components/sectional";
import { BankLookupSmartDemo } from "../components/bank-lookup-smart";
import { SidebarDemo } from "../components/sidebar/SidebarDemo";
import { useState } from "react";

export const Demo = () => {
    const [active, setActive] = useState("csl");
    const list = ["csl", "sectionals", "banks"];
    return (
        <Stack direction={"row"} gap={5} alignItems={"flex-start"}>
            <SidebarDemo list={list} active={active} setActive={setActive} />
            <Stack py={4} width={"820px"}>
                {/* CSL SMART COMPONENT */}
                {active === "csl" && <CslFormSmartDemo />}
                {/* SECTIONAL SMART COMPONENT */}
                {active === "sectionals" && <SectionalDemo />}
                {/* BANK SMART COMPONENT */}
                {active === "banks" && <BankLookupSmartDemo />}
            </Stack>
        </Stack>
    );
};
